export const FormLabelText = {
  MANDATORY: ' *',
  GIFT_CARD_VALUE: 'Gift card value',
  NAME: 'Name',
  EMAIL: 'Email address',
  TITLE_SEND: 'Send it to',
  TITLE_SEND_SUBTITLE: 'Recipients directly',
  TITLE_SEND_INFORMATION: 'Add up to 9 people',
  TITLE_GIFT_CARD: 'Customise gift card value',
  TITLE_GIFT_CARD_INFORMATION: 'Enter an amount or select a value',
  TITLE_CSV: 'For 10 or more, upload a CSV file',
  ADD_RECIPIENT_BUTTON: 'Add Recipient',
  UPLOAD_CSV_BUTTON: 'Add in bulk',
  TITLE_EMAIL: 'My email',
  TITLE_EMAIL_INFORMATION: "I'll distribute the gift cards myself",
  TITLE_QUANTITY: 'Quantity ',
  TITLE_QUANTITY_INFORMATION: 'Number of gift cards',
  TITLE_MESSAGE: 'Write a message',
  MESSAGE_DEFAULT: "Here's a foodpanda gift card for you!",
  TITLE_TNC: 'Terms & conditions',
  TITLE_TNC_LINE_1: 'Valid for %duration_period%',
  TITLE_TNC_LINE_2: 'Gift cards can be used for delivery fees and GST',
  TITLE_TNC_LINE_3:
    'Gift cards will be sent after we have verified your payment and business information',
  TITLE_TNC_LINE_4: 'Valid for use in %country% only',
  TITLE_TNC_LINE_5:
    'is not responsible for any failure in distribution of gift cards due to incorrect email addresses',
  TOOLTIP_TEXT:
    'Choose to receive all gift card numbers in 1 email. Next, send them to your recipients to enjoy!',
  TNC: 'Terms & conditions',
  TNC_ERROR_TEXT:
    'It is required to agree with the terms & conditions and privacy policy to continue',
  GIFT_CARD_VALUE_ERROR_TEXT: 'Enter a gift card value',
  MESSAGE_ERROR_TEXT: 'Enter a gift card message',
  QUANTITY_ERROR_TEXT: 'Quantity is required',
  NEGATIVE_VALUE_ERROR_TEXT: 'Value cannot be negative',
  MIN_VALUE_ERROR_TEXT: 'Minimum gift card value is',
  MAX_VALUE_ERROR_TEXT: 'Maximum gift card value is',
  NAME_ERROR_TEXT: "Enter recipient's first name",
  EMAIL_ERROR_TEXT: "Enter recipient's email address",
  UPLOAD_CSV_INFORMATION:
    'Make sure that all email addresses are correct. In the case of incorrect email addresses, you are responsible for retrieving the gift card details and sending them to your recipients manually.'
};
